module.exports = __webpack_public_path__ + "img/img-10.bc3da254.png";